export type OpenOrderLike = {
  orderState?: string;
};

export const isOpenOrder = (order?: OpenOrderLike | null): boolean => {
  return order?.orderState === 'Open';
};
